import React from "react";
import Footer from "./Footer";
import Header from "./Header";
import MenuBar from "./MenuBar";
import { Typography } from "@mui/material";

const PageNotFound = () => {
  return (
    <>
      <div className="content-wrapper" style={{ backgroundColor: "white" }}>
        <section className="content">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "100px",
            }}
          >
            <img src="/assets/pageNotFound.svg" alt="pagenotFound" />
            <Typography
              className="headerH2Bold"
              style={{ color: "#000", marginTop: "52px" }}
            >
              Oops! Page not found
            </Typography>
            <Typography
              className="bodyB1Medium font-black-medium"
              style={{ marginTop: "8px" }}
            >
              Please change the URL or try going to a different page
            </Typography>
          </div>
        </section>
      </div>
    </>
  );
};

export default PageNotFound;
